import React from "react";
import LegalPage from "./LegalPage";

const sections = [
  {
    heading: "Overview",
    blocks: [
      {
        type: "p",
        text: 'This Privacy Policy explains how Sassy Full Stack Fitness ("we," "us," or "our") collects, uses, and protects your information when you use our Transformation Calculator (the "Tool") at sassyfitness.com. By using the Tool and submitting your information, you agree to the practices described here.',
      },
    ],
  },
  {
    heading: "Information We Collect",
    blocks: [
      {
        type: "ul",
        items: [
          { label: "Contact details:", text: "your name, email address, and mobile phone number." },
          {
            label: "Body & fitness inputs:",
            text: "gender, age, height, weight, activity level, and current/target body-fat percentages you enter.",
          },
          { label: "Photos (optional):", text: "any photo you upload to generate a transformation preview." },
          {
            label: "Consent & technical data:",
            text: "if you opt in to text messages, we record the date/time, IP address, and browser of your consent.",
          },
        ],
      },
    ],
  },
  {
    heading: "How We Use Your Information",
    blocks: [
      {
        type: "ul",
        items: [
          "To calculate your personalized macros and generate your transformation preview.",
          "To deliver your results and follow up about our coaching services by email and, if you opt in, by text message.",
          "To improve the Tool and our services.",
        ],
      },
    ],
  },
  {
    heading: "Text Messaging (SMS) Program & Opt-In",
    blocks: [
      {
        type: "p",
        label: "How you opt in:",
        text: "On our website form you enter your name, email, and mobile number, and you actively check an opt-in box (not pre-checked) that reads:",
      },
      {
        type: "quote",
        text: '"By checking this box, I agree to receive recurring automated marketing & informational text messages (e.g. my results & coaching info) from Sassy Full Stack Fitness at the number provided. Consent is not a condition of purchase. Msg frequency varies. Msg & data rates may apply. Reply STOP to opt out, HELP for help."',
      },
      {
        type: "p",
        text: "A link to our Privacy Policy and Terms is shown directly at the point of consent.",
      },
      {
        type: "p",
        label: "What we send:",
        text: "your personalized results confirmation and a link to schedule a coaching call. Example message:",
      },
      {
        type: "quote",
        text: '"Sassy Full Stack Fitness: Hi Sarah, your personalized macros are ready! If you\'d like coaching, book a time here: [scheduling link]. Reply STOP to opt out, HELP for help. Msg & data rates may apply."',
      },
      {
        type: "p",
        label: "Frequency:",
        text: "message frequency varies. Message and data rates may apply.",
      },
      {
        type: "p",
        label: "Opting out / help:",
        text: "reply STOP to any message to unsubscribe; reply HELP for help. Carriers are not liable for delayed or undelivered messages.",
      },
      {
        type: "p",
        emphasis: true,
        text: "No mobile information will be shared with third parties or affiliates for marketing or promotional purposes. Text messaging originator opt-in data and consent will not be shared with any third parties.",
      },
    ],
  },
  {
    heading: "AI-Generated Transformation Images",
    blocks: [
      {
        type: "p",
        text: 'If you upload a photo, it is securely sent to a third-party AI image provider (Google Gemini) solely to generate your "future you" preview. Your uploaded photo and the generated image are stored to display your results. We do not sell your photos, and we do not use them to identify you elsewhere. You can request deletion of your photos at any time (see "Your Choices" below).',
      },
    ],
  },
  {
    heading: "How We Share Information",
    blocks: [
      {
        type: "p",
        text: "We do not sell your personal information. We share it only with service providers who help us operate the Tool, such as our cloud hosting/database providers, Google Gemini (AI image generation), our SMS provider (Twilio, to deliver texts you opt in to), and our email provider. We may also disclose information if required by law. As stated above, SMS opt-in data and consent are never shared with third parties.",
      },
      {
        type: "p",
        text: "We use Google Analytics and Microsoft Clarity to understand how visitors use our site. These tools may use cookies and collect anonymous usage data.",
      },
    ],
  },
  {
    heading: "Data Retention & Security",
    blocks: [
      {
        type: "p",
        text: "We keep your information for as long as needed to provide our services and for legitimate business or legal purposes. We use reasonable technical and organizational measures to protect your data, though no method of transmission or storage is 100% secure.",
      },
    ],
  },
  {
    heading: "Your Choices & Rights",
    blocks: [
      {
        type: "ul",
        items: [
          "Unsubscribe from emails using the link in any email.",
          "Opt out of texts by replying STOP.",
          "Request access to, correction of, or deletion of your personal information and uploaded photos by contacting us below.",
        ],
      },
    ],
  },
  {
    heading: "Contact Us",
    blocks: [
      {
        type: "p",
        text: "Questions about this policy or your data? Contact us at privacy@sassyfitness.com or visit sassyfitness.com.",
      },
    ],
  },
];

const Privacy = () => (
  <LegalPage
    title="Privacy"
    accent="Policy"
    updated="Last updated: August 2026"
    sections={sections}
    testId="privacy-page"
    docTitle="Privacy Policy | Sassy Full Stack Fitness"
  />
);

export default Privacy;
